exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3MsjB{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"slick-track": "_3MsjB",
	"slickTrack": "_3MsjB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/views/home/components/mobile-carousel/track.styl
// module id = 2796
// module chunks = mobile/mobile